import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingListComponent } from './meeting-list.component';
import { HttpStripPipe } from './http-strip.pipe';
import { MeetingTypeFilterComponent } from './meeting-type-filter/meeting-type-filter.component';
import { DeleteBookingLinkConfirmationDialogComponent } from './delete-booking-link-confirmation-dialog/delete-booking-link-confirmation-dialog.component';
import { BookingUrlDialogComponent } from './booking-url-dialog/booking-url-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MeetingTypeModule } from '../meeting-type/meeting-type.module';
import { RescheduleMeetingButtonModule } from '../meeting-actions/reschedule/reschedule-meeting-button.module';
import { CancelMeetingButtonModule } from '../meeting-actions/cancel/cancel-meeting-button.module';
import { UIKitModule } from '@vendasta/uikit';
import { VaFormsModule } from '@vendasta/forms';
import { NavigationModule } from '../sales-center-navigation/navigation.module';
import { MeetingSchedulerSharedModule } from '../shared/meeting-scheduler-shared.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatDivider } from '@angular/material/divider';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { GalaxyFilterChipsModule } from '@vendasta/galaxy/filter/chips';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BlankValueRendererComponent } from '@vendasta/galaxy/table/src/components/model-driven-cell/renderers/blank-value';
import { GroupAndServiceComponent } from './table-and-grid-view/events-group-and-service.component';
import { MeetingListLoadDataService } from './table-and-grid-view/load-data-service.service';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { TruncatePipe } from './table-and-grid-view/truncate.pipe';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';

@NgModule({
  declarations: [
    MeetingListComponent,
    HttpStripPipe,
    TruncatePipe,
    MeetingTypeFilterComponent,
    DeleteBookingLinkConfirmationDialogComponent,
    BookingUrlDialogComponent,
    GroupAndServiceComponent,
  ],
  imports: [
    MeetingSchedulerSharedModule,
    TranslateModule,
    CommonModule,
    LayoutModule,
    MatDialogModule,
    NavigationModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    RouterModule,
    ClipboardModule,
    MatExpansionModule,
    MatCardModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MeetingTypeModule,
    RescheduleMeetingButtonModule,
    CancelMeetingButtonModule,
    UIKitModule,
    FormsModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    VaFormsModule,
    MatSelectModule,
    GalaxyEmptyStateModule,
    MatDivider,
    MatGridList,
    MatGridTile,
    GalaxyFormFieldModule,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatButtonToggleModule,
    GalaxyAlertModule,
    GalaxyTableModule,
    GalaxyFilterChipsModule,
    MatTable,
    MatSort,
    MatHeaderRow,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRowDef,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatTooltipModule,
    GalaxyTooltipModule,
    MatRow,
    MatRowDef,
    GalaxyButtonGroupModule,
    MatSortModule,
    BlankValueRendererComponent,
    GalaxyLoadingSpinnerModule,
  ],
  exports: [MeetingListComponent, TruncatePipe, GroupAndServiceComponent],
  providers: [MeetingListLoadDataService],
})
export class MeetingListModule {}
